import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import FormPage from "@/pages/FormPage";
import Result from "@/pages/Result";
import AnalyseForm from "@/pages/AnalyseForm";
import Weiter from "@/pages/Weiter";
import Report from "@/pages/Report";
import Feedback from "@/pages/Feedback";
import Gruendungszuschuss from "@/pages/Gruendungszuschuss";
import Invoice from "@/pages/Invoice";
import Impressum from "@/pages/legal/Impressum";
import Datenschutz from "@/pages/legal/Datenschutz";
import AGB from "@/pages/legal/AGB";
import Widerruf from "@/pages/legal/Widerruf";
import BranchePage from "@/pages/BranchePage";
import LandingTemplate from "@/pages/LandingTemplate";
import { landingPages } from "@/content/landings";
import ContentLanding from "@/pages/ContentLanding";
import Admin from "@/pages/Admin";
import Business from "@/pages/Business";
import { contentLandings } from "@/content/contentLandings";

function AnalyseRedirect() {
  const { id } = useParams();
  return <Navigate to={`/report-erstellen/${id}`} replace />;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gruender" element={<Landing />} />
            <Route path="/business" element={<Business />} />
            <Route path="/gruendungszuschuss" element={<Gruendungszuschuss />} />
            <Route path="/geschaeftsidee-pruefen-lassen" element={<LandingTemplate content={landingPages["geschaeftsidee-pruefen-lassen"]} />} />
            <Route path="/einstiegsgeld" element={<LandingTemplate content={landingPages["einstiegsgeld"]} />} />
            <Route path="/geschaeftsidee-testen" element={<ContentLanding content={contentLandings["geschaeftsidee-testen"]} />} />
            <Route path="/feedback-geschaeftsidee" element={<ContentLanding content={contentLandings["feedback-geschaeftsidee"]} />} />
            <Route path="/branchen-check" element={<ContentLanding content={contentLandings["branchen-check"]} />} />
            <Route path="/form" element={<FormPage />} />
            <Route path="/result/:id" element={<Result />} />
            <Route path="/teaser/:id" element={<Result />} />
            <Route path="/report-erstellen/:id" element={<AnalyseForm />} />
            <Route path="/analyse/:id" element={<AnalyseRedirect />} />
            <Route path="/weiter/:id" element={<Weiter />} />
            <Route path="/invoice/:id" element={<Invoice />} />
            <Route path="/report/:id" element={<Report />} />
            <Route path="/feedback/:id" element={<Feedback />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/widerruf" element={<Widerruf />} />
            <Route path="/branchen/:slug" element={<BranchePage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
